import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"none\" fill-rule=\"evenodd\" stroke=\"currentcolor\" stroke-linecap=\"round\"><circle cx=\"18.75\" cy=\"17.25\" r=\"1.75\"></circle><circle cx=\"5.75\" cy=\"17.25\" r=\"1.75\"></circle><path stroke-linejoin=\"round\" d=\"M5.758 5.59h9.272v9.487\"></path><path d=\"M.881 12H7.75\"></path><path stroke-linejoin=\"round\" d=\"M2.03 15.073h20.927l-.309-3.17a1 1 0 0 0-.564-.805l-.996-.475a1 1 0 0 1-.509-.562l-.853-2.35a1 1 0 0 0-.834-.654l-3.642-.389h0\"></path><path d=\"M3.303 8.75h5.609M7.5 16.5H17\"></path></g>", 1)
  ])))
}
export default { render: render }